module.exports = __webpack_public_path__ + "img/duotu.b27356d2.png";